<template>
  <div>
    <b-modal v-model="showModal"
      title="Mensaje"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc>
        Desea eliminar el registo <strong>{{ code }}</strong>?
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
          <button @click="submit" class="btn btn-sm btn-success"> <i class="fas fa-check fa-fw"></i> Aceptar</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['id','code', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
    }
  },
  methods:{
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
      this.$emit('getRecords')
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
    submit() {
      this.loading = true
      axios.get(`/administration/courses/courses/destroy/${this.form.id}`)
        .then(response => {
          if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
          }
          this.close();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

</script>